import { useAvaiableTeacherPacks } from '../../api/useAvaiableTeacherPacks'
import { TeacherPacksCard } from '@shared/ui/teacher-packs-card/teacher-packs-card'

export const TeacherPacks = ({ teacher, packs: packsProp, singleLessonPrice, onSelect, selectedId, loadingId, showEmpty, selectable, disabled, disabledMessage, variant }) => {
    const { data: packsFromHook } = useAvaiableTeacherPacks(teacher)
    const packs = packsProp ?? packsFromHook

    if (packs === undefined) return null

    return (
        <TeacherPacksCard
            packs={packs}
            singleLessonPrice={singleLessonPrice}
            onSelect={onSelect}
            selectedId={selectedId}
            loadingId={loadingId}
            showEmpty={showEmpty}
            selectable={selectable}
            disabled={disabled}
            disabledMessage={disabledMessage}
            variant={variant}
        />
    )
}
